import { createSlice } from '@reduxjs/toolkit'

export const limitSlice = createSlice({
    name: 'limit',
    initialState: {
        value: []
    },
    reducers: {
        limitAction: (state, action) => {
            state.value = action.payload
        },
    },
})

export const { limitAction } = limitSlice.actions

export default limitSlice.reducer
